import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import { Button } from '@/app/common/components/button/Button'
import Badge from '@/app/common/components/Badge'
import type { NonGradeModifierCardProps } from '../modifiers/types'

export default function NonGradeModifierCard({
  modifierName,
  isActive,
  onConfigure,
}: NonGradeModifierCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <h3 className="text-base sm:text-lg font-semibold text-gray-900">
          {modifierName} - Additional Distribution Rule
        </h3>
        <Badge semanticColor={isActive ? 'Positive' : 'Negative'}>
          {isActive ? 'Active' : 'Inactive'}
        </Badge>
      </CardHeader>
      <CardContent>
        <Button size="sm" variant="primary" onClick={onConfigure}>
          Configure
        </Button>
      </CardContent>
    </Card>
  )
}
